import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      title: 'Brixel Technologies — IA, IoT y visión computacional para operaciones críticas',
      description: 'Diseñamos sistemas de monitoreo, detección y analítica en tiempo real para industrias donde cada variable cuenta.',
    },
  },
  {
    path: '/soluciones',
    name: 'solutions',
    component: () => import('@/views/SolucionesView.vue'),
    meta: {
      title: 'Soluciones | Brixel Technologies',
      description: 'Aeris, Brixmog, Brixion y Climate Intelligence. Sistemas de sensado, visión computacional y analítica para operaciones críticas.',
    },
  },
  {
    path: '/industrias',
    name: 'industries',
    component: () => import('@/views/IndustriasView.vue'),
    meta: {
      title: 'Industrias | Brixel Technologies',
      description: 'Tecnología para avicultura, porcicultura, seguridad industrial, cuartos de servidores, campo y seguros.',
    },
  },
  {
    path: '/tecnologia',
    name: 'technology',
    component: () => import('@/views/TecnologiaView.vue'),
    meta: {
      title: 'Tecnología | Brixel Technologies',
      description: 'Hardware propio, Edge AI, GSM/LTE, dashboards. Del dato físico a la alerta accionable.',
    },
  },
  {
    path: '/empresa',
    name: 'about',
    component: () => import('@/views/EmpresaView.vue'),
    meta: {
      title: 'Empresa | Brixel Technologies',
      description: 'Inteligencia para el mundo físico. Brixel Technologies nace entre México y Colombia.',
    },
  },
  {
    path: '/contacto',
    name: 'contact',
    component: () => import('@/views/ContactView.vue'),
    meta: {
      title: 'Contacto | Brixel Technologies',
      description: 'Agenda un diagnóstico. Diseñamos una solución adaptada a tu entorno operativo.',
    },
  },
  { path: '/servicios', redirect: '/soluciones' },
  { path: '/nosotros', redirect: '/empresa' },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0, behavior: 'smooth' }
  },
})

export default router
